import React from "react";
import { Header } from "@nef/core";
import styled from "styled-components";

const StyledAppHeader = styled(Header)`
  &.app-header {
    font-weight: 300;
    display: flex;
    color: white;
    background-image: linear-gradient(301deg, rgba(44, 34, 150, 0), #7b2297),
      linear-gradient(rgba(0, 82, 154, 0.95), rgba(0, 82, 154, 0.95)),
      linear-gradient(121deg, #3fcc6f, #3fcc6f),
      linear-gradient(238deg, rgba(173, 32, 142, 0), #ad208e),
      linear-gradient(
        42deg,
        rgba(0, 190, 213, 0),
        rgba(0, 190, 213, 0.85) 85%,
        rgba(0, 190, 213, 0.87) 87%,
        #00bed5
      ),
      linear-gradient(126deg, rgba(0, 190, 213, 0), #00bed5),
      linear-gradient(#594099, #594099);
    position : relative;
    .text {
      color: white;

      padding-top: 2em;
      padding-left: 3em;
      padding-bottom: 2em;
      font-family: sans-serif;
      font-size: 2.5rem;
      font-weight: 100;
    }
  }
`;

export default StyledAppHeader;
